// extracted by mini-css-extract-plugin
module.exports = {"note":"NotesListItem_note__yXqiP","noteDate":"NotesListItem_noteDate__Rc6YB","seeMore":"NotesListItem_seeMore__yewWc","itemBody":"NotesListItem_itemBody__XYxrq"};